import { z } from 'zod';

/**
 * Gli id persistiti sono UUID v4 generati da Prisma, ma i dati demo/seed usano id
 * UUID-shaped senza version nibble RFC: `z.uuid()` (Zod 4) li rifiuta.
 */
export const UUID_LIKE_REGEX =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const IdentifierSchema = z.string().regex(UUID_LIKE_REGEX, 'Invalid identifier');
